/* Generated by restful-react */

import React from 'react'
import { Mutate, MutateProps, useMutate, UseMutateProps } from 'restful-react'

export const SPEC_VERSION = 'v9'
export interface ShipperStrikePriceOverrideFilters {
  shipperStrikePriceId?: number
}

export interface ShipperStrikePriceOverridesResponse {
  shipperStrikePriceOverrides?: ShipperStrikePriceOverride[]
}

export interface ShipperStrikePriceOverrideErrorResponse {
  errors?: string[]
}

export interface ShipperStrikePriceOverride {
  id?: number
  shipperStrikePriceId: number
  overridePercentage: number
  reason: string
  startAt: string
  endAt: string
}

export type CreateShipperStrikePriceOverrideProps = Omit<
  MutateProps<
    void,
    ShipperStrikePriceOverrideErrorResponse,
    void,
    ShipperStrikePriceOverride,
    void
  >,
  'path' | 'verb'
>

/**
 * Create a new shipper strike price override
 */
export const CreateShipperStrikePriceOverride = (props: CreateShipperStrikePriceOverrideProps) => (
  <Mutate<void, ShipperStrikePriceOverrideErrorResponse, void, ShipperStrikePriceOverride, void>
    verb='POST'
    path='/v9/shipper_strike_price_overrides'
    {...props}
  />
)

export type UseCreateShipperStrikePriceOverrideProps = Omit<
  UseMutateProps<
    void,
    ShipperStrikePriceOverrideErrorResponse,
    void,
    ShipperStrikePriceOverride,
    void
  >,
  'path' | 'verb'
>

/**
 * Create a new shipper strike price override
 */
export const useCreateShipperStrikePriceOverride = (
  props: UseCreateShipperStrikePriceOverrideProps
) =>
  useMutate<void, ShipperStrikePriceOverrideErrorResponse, void, ShipperStrikePriceOverride, void>(
    'POST',
    `/v9/shipper_strike_price_overrides`,
    props
  )

export interface UpdateShipperStrikePriceOverridePathParams {
  /**
   * Id of shipper strike price override to update
   */
  shipperStrikePriceOverrideId: number
}

export type UpdateShipperStrikePriceOverrideProps = Omit<
  MutateProps<
    void,
    ShipperStrikePriceOverrideErrorResponse,
    void,
    ShipperStrikePriceOverride,
    UpdateShipperStrikePriceOverridePathParams
  >,
  'path' | 'verb'
> &
  UpdateShipperStrikePriceOverridePathParams

/**
 * Update an existing strike price override
 */
export const UpdateShipperStrikePriceOverride = ({
  shipperStrikePriceOverrideId,
  ...props
}: UpdateShipperStrikePriceOverrideProps) => (
  <Mutate<
    void,
    ShipperStrikePriceOverrideErrorResponse,
    void,
    ShipperStrikePriceOverride,
    UpdateShipperStrikePriceOverridePathParams
  >
    verb='PUT'
    path={`/v9/shipper_strike_price_overrides/${shipperStrikePriceOverrideId}`}
    {...props}
  />
)

export type UseUpdateShipperStrikePriceOverrideProps = Omit<
  UseMutateProps<
    void,
    ShipperStrikePriceOverrideErrorResponse,
    void,
    ShipperStrikePriceOverride,
    UpdateShipperStrikePriceOverridePathParams
  >,
  'path' | 'verb'
> &
  UpdateShipperStrikePriceOverridePathParams

/**
 * Update an existing strike price override
 */
export const useUpdateShipperStrikePriceOverride = ({
  shipperStrikePriceOverrideId,
  ...props
}: UseUpdateShipperStrikePriceOverrideProps) =>
  useMutate<
    void,
    ShipperStrikePriceOverrideErrorResponse,
    void,
    ShipperStrikePriceOverride,
    UpdateShipperStrikePriceOverridePathParams
  >(
    'PUT',
    (paramsInPath: UpdateShipperStrikePriceOverridePathParams) =>
      `/v9/shipper_strike_price_overrides/${paramsInPath.shipperStrikePriceOverrideId}`,
    { pathParams: { shipperStrikePriceOverrideId }, ...props }
  )

export type DeleteShipperStrikePriceOverrideProps = Omit<
  MutateProps<void, unknown, void, number, void>,
  'path' | 'verb'
>

/**
 * Delete an existing shipper strike price override
 */
export const DeleteShipperStrikePriceOverride = (props: DeleteShipperStrikePriceOverrideProps) => (
  <Mutate<void, unknown, void, number, void>
    verb='DELETE'
    path='/v9/shipper_strike_price_overrides'
    {...props}
  />
)

export type UseDeleteShipperStrikePriceOverrideProps = Omit<
  UseMutateProps<void, unknown, void, number, void>,
  'path' | 'verb'
>

/**
 * Delete an existing shipper strike price override
 */
export const useDeleteShipperStrikePriceOverride = (
  props: UseDeleteShipperStrikePriceOverrideProps
) =>
  useMutate<void, unknown, void, number, void>('DELETE', `/v9/shipper_strike_price_overrides`, {
    ...props,
  })
